import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M3 3v12h12V3H3zm10.667 10.667H4.333V4.333h9.334v9.334z" fill="#54585D" /></svg>);